import { render, staticRenderFns } from "./TweBank.vue?vue&type=template&id=77833d5c&scoped=true&slot-scope=scope&"
import script from "./TweBank.vue?vue&type=script&lang=js&"
export * from "./TweBank.vue?vue&type=script&lang=js&"
import style0 from "./TweBank.vue?vue&type=style&index=0&id=77833d5c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77833d5c",
  null
  
)

export default component.exports